const ResizeMixin = {
  props: {
    judgementSize: {
      type: Number,
      default: 100
    }
  },

  data: function() {
    return {
      overflowed: false
    };
  },

  mounted: function() {
    this.resize();
  },

  methods: {
    resize: function() {
      this.overflowed = false;
      this.$nextTick(function() {
        if (!this.$refs.overflowJudge) {
          return this.overflowed = false;
        }
        if (0 < this.$refs.overflowJudge.getBoundingClientRect().width && this.$refs.overflowJudge.getBoundingClientRect().width < this.judgementSize) {
          this.overflowed = true;
        } else {
          this.overflowed = false;
        }
      });
    }
  }
};

export default ResizeMixin;
